import { withZones } from '@beef/react/enhancers';
import { cnTheme } from '@carnica/themes';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { templateParser } from "../../utils/strings";
import style from "./styles.pcss";
import { COPYRIGHT, EChild } from "./constants";
var cn = classNames.bind(style);
export var ModalLayout = withZones(Object.keys(EChild))( /*#__PURE__*/memo(function (props) {
  var zones = props.zones,
    copyright = props.copyright,
    className = props.className;
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', cnTheme())
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('header')
  }, zones[EChild.Header]), /*#__PURE__*/React.createElement("div", {
    className: cn('content', className)
  }, zones[EChild.Content], zones[EChild.Buttons] && /*#__PURE__*/React.createElement("div", {
    className: cn('buttons')
  }, zones[EChild.Buttons])), /*#__PURE__*/React.createElement(Text, {
    className: cn('copyright'),
    color: "tertiary",
    size: 14
  }, copyright !== null && copyright !== void 0 ? copyright : templateParser(COPYRIGHT, {
    year: new Date().getFullYear().toString()
  }))), document.body);
}));